var O = /* @__PURE__ */ ((N) => (N[N.ONLY_TAKEAWAY = 1] = "ONLY_TAKEAWAY", N[N.ONLY_DELIVERY = 2] = "ONLY_DELIVERY", N[N.ONLY_DINE_IN = 3] = "ONLY_DINE_IN", N[N.ONLY_BOOK = 4] = "ONLY_BOOK", N[N.BASE = 100] = "BASE", N))(O || {});
export {
  O as RestaurantUrl
};
//# sourceMappingURL=restaurant-url.enum.js.map
